import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { ButtonProps } from 'features/ui/elements';
import { Button } from 'features/ui/elements';

export const CallDetailsButtonCancel: FC<
  Pick<ButtonProps, 'onClick' | 'loading' | 'hotkey' | 'disabled'>
> = ({ loading, onClick, hotkey, disabled }) => {
  const { t } = useTranslation();
  return (
    <Button
      fullWidth
      size='small'
      color='primary'
      loading={loading}
      onClick={onClick}
      hotkey={hotkey}
      disabled={disabled}
    >
      {disabled ? t('connecting') : t('cancel')}
    </Button>
  );
};
